import label from './radar.data.label'
import itemStyle from './radar.data.itemStyle'
import lineStyle from './radar.data.lineStyle'
import areaStyle from './radar.data.areaStyle'
import emphasis from './radar.data.emphasis'
import tooltip from './radar.data.tooltip'

export default {
  name: "data",
  nickname: "数据",
  desc: "雷达图的数据是多变量（维度）的，如下示例：",
  type: "array",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc: "数据项名称",
    },
    value: {
      name: "value",
      nickname: "值",
      desc: "单个数据项的数值。",
      type: "pureValue",
    },
    symbol: {
      name: "symbol",
      nickname: "箭头",
      desc: "单个数据标记的图形。",
      value: "circle",
      defaultValue: "circle",
      type: "pureValue",
    },
    symbolSize: {
      name: "symbolSize",
      nickname: "箭头大小",
      desc:
        '单个数据标记的大小，可以设置成诸如 <code class="codespan">10</code> 这样单一的数字，也可以用数组分开表示宽和高，例如 <code class="codespan">[20, 10]</code> 表示标记宽为<code class="codespan">20</code>，高为<code class="codespan">10</code>。',
      value: 4,
      defaultValue: 4,
      type: "pureValue",
    },
    symbolRotate: {
      name: "symbolRotate",
      nickname: "旋转角度",
      desc:
        '单个数据标记的旋转角度。注意在 <code class="codespan">markLine</code> 中当 <code class="codespan">symbol</code> 为 <code class="codespan">&#39;arrow&#39;</code> 时会忽略 <code class="codespan">symbolRotate</code> 强制设置为切线的角度。',
    },
    symbolKeepAspect: {
      name: "symbolKeepAspect",
      nickname: "symbolKeepAspect",
      desc:
        '如果 <code class="codespan">symbol</code> 是 <code class="codespan">path://</code> 的形式，是否在缩放时保持该图形的长宽比。',
      value: false,
      defaultValue: false,
    },
    symbolOffset: {
      name: "symbolOffset",
      nickname: "箭头偏移",
      desc:
        "单个数据标记相对于原本位置的偏移。默认情况下，标记会居中置放在数据对应的位置，但是如果 symbol 是自定义的矢量路径或者图片，就有可能不希望 symbol 居中。这时候可以使用该配置项配置 symbol 相对于原本居中的偏移，可以是绝对的像素值，也可以是相对的百分比。",
      value: [0, 0],
      defaultValue: [0, 0],
      type: "pureValue",
    },
    label,
    itemStyle,
    lineStyle,
    areaStyle,
    emphasis,
    tooltip,
  },
}
